import { Button } from '@/components/ui/button'
import { CircleMinus, CirclePlus } from 'lucide-react'

interface AddButtonProps {
  text?: string
  onClick: () => void
  disabled?: boolean
  isMinus?: boolean
}

const AddButton: React.FC<AddButtonProps> = (props) => {
  const { text, onClick, disabled, isMinus } = props

  const isPlus = !isMinus

  return (
    <Button onClick={onClick} disabled={disabled} variant='ghost' type='button'>
      {isMinus && <CircleMinus />}
      {isPlus && <CirclePlus />} {text}
    </Button>
  )
}

export default AddButton
